import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject, signal } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'
import { MatToolbarModule } from '@angular/material/toolbar'
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular'
import { OktaAuth } from '@okta/okta-auth-js'
import packageJson from '../../package.json'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      RouterModule,
      MatToolbarModule,
      MatButtonModule,
    ]
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _oktaStateService = inject(OktaAuthStateService)
  private readonly _oktaAuth = inject<OktaAuth>(OKTA_AUTH)

  title = 'ersagent-frontend'
  authenticated = signal(false)
  firstName = signal('')
  lastName = signal('')
  clientId = signal('')
  clientSecret = signal('')
  appVersion: string = packageJson.version

  private _subscription: Subscription | undefined

  ngOnInit(): void {
    this._subscription = this._oktaStateService.authState$.subscribe((authState) => {
      this.authenticated.set(authState.isAuthenticated ?? false)
      if (this.authenticated()) {
        this.firstName.set(authState.idToken?.claims['firstName']?.toString() ?? '')
        this.lastName.set(authState.idToken?.claims['lastName']?.toString() ?? '')
        this.clientId.set(authState.idToken?.claims['ers_gtw_client_id'] as string ?? '')
        this.clientSecret.set(authState.idToken?.claims['ers_gtw_client_secret'] as string ?? '')
      }
    })
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe()
  }

  public async signOut (): Promise<void> {
    try {
      await this._oktaAuth.signOut()
    } catch (e) {
      console.error(e)
    }
  }
}
